import * as React from 'react';
import { SVGProps } from 'react';

const VideoPlaying = ({ ...props }: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <g
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
    >
      <path d="M19.889 3.389H4.111A1.11 1.11 0 0 0 3 4.5v10a1.11 1.11 0 0 0 1.111 1.111h15.778A1.11 1.11 0 0 0 21 14.5v-10a1.11 1.11 0 0 0-1.111-1.111ZM8.56 18.94a1.5 1.5 0 1 1-2.12 2.12 1.5 1.5 0 0 1 2.12-2.12M21 20H9M3 20h3" />
    </g>
  </svg>
);
export default VideoPlaying;
